import { render } from "./SerieForm.vue?vue&type=template&id=489f081f&scoped=true"
import script from "./SerieForm.vue?vue&type=script&lang=js"
export * from "./SerieForm.vue?vue&type=script&lang=js"

import "./SerieForm.vue?vue&type=style&index=0&id=489f081f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489f081f"]])

export default __exports__